import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Modal, Input, Button, Space, Typography, Alert, message } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFileAlt, faSave } from '@fortawesome/free-solid-svg-icons'

const { Title, Text } = Typography

const SaveToDocsModal = ({ visible, onCancel, onSave, content, isLoading = false }) => {
  const [documentType, setDocumentType] = useState('')

  const handleSave = async () => {
    if (!documentType.trim()) {
      message.error('Please enter a document type')
      return
    }

    try {
      await onSave(documentType.trim())
      // Reset form and close modal
      setDocumentType('')
      onCancel()
    } catch (error) {
      // Error handling is done in the parent component
    }
  }

  const handleCancel = () => {
    setDocumentType('')
    onCancel()
  }

  const suggestedTypes = [
    'Referral Letter',
    'Patient Handout',
    'Treatment Plan',
    'Discharge Summary',
    'Care Instructions',
    'Medical Certificate',
    'Assessment Report'
  ]

  return (
    <Modal
      title={
        <Space>
          <FontAwesomeIcon icon={faFileAlt} />
          <span>Save to Documents</span>
        </Space>
      }
      open={visible}
      onCancel={handleCancel}
      footer={[
        <Button key='cancel' onClick={handleCancel} disabled={isLoading}>
          Cancel
        </Button>,
        <Button
          key='save'
          type='primary'
          onClick={handleSave}
          loading={isLoading}
          icon={<FontAwesomeIcon icon={faSave} />}
        >
          Save to Documents
        </Button>
      ]}
      width={500}
      maskClosable={!isLoading}
      closable={!isLoading}
    >
      <div style={{ marginBottom: '16px' }}>
        <Title level={5} style={{ marginBottom: '8px' }}>
          Document Type
        </Title>
        <Text type='secondary' style={{ marginBottom: '16px', display: 'block' }}>
          Enter a name/type for this document (e.g., "Referral Letter", "Patient Handout", etc.)
        </Text>

        <Input
          placeholder='Enter document type...'
          value={documentType}
          onChange={(e) => setDocumentType(e.target.value)}
          onPressEnter={handleSave}
          disabled={isLoading}
          style={{ marginBottom: '16px' }}
        />

        {/* Quick suggestions */}
        <div style={{ marginBottom: '16px' }}>
          <Text style={{ fontSize: '12px', color: '#8c8c8c', marginBottom: '8px', display: 'block' }}>
            Quick suggestions:
          </Text>
          <Space size={[8, 8]} wrap>
            {suggestedTypes.map((type) => (
              <Button
                key={type}
                size='small'
                type='link'
                style={{
                  padding: '2px 8px',
                  height: 'auto',
                  fontSize: '12px',
                  border: '1px solid #d9d9d9',
                  borderRadius: '4px'
                }}
                onClick={() => setDocumentType(type)}
                disabled={isLoading}
              >
                {type}
              </Button>
            ))}
          </Space>
        </div>

        <Alert
          message='Document will be saved to the Documents section where it can be viewed, downloaded, and managed.'
          type='info'
          showIcon
          style={{ fontSize: '12px' }}
        />
      </div>
    </Modal>
  )
}

SaveToDocsModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  content: PropTypes.string.isRequired,
  isLoading: PropTypes.bool
}

export default SaveToDocsModal
